.container {
    background-color: var(--color-white);
}

.wrapper {
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-bottom: 2rem;

    &[aria-hidden="true"] {
        display: none;
    }
}

.imageWrapper {
    max-height: 500px;
    position: relative;
}

.image {
    max-width: 534px;
    width: 100%;
}

.expiresOn {
    font-size: 1rem;
    left: 56%;
    position: absolute;
    top: 52%;
}

.thankYouHeading {
    font-size: 2.5rem;
    text-transform: uppercase;
}
